export function formatFuroLabel(temFuro?: boolean | number, tipoFuro?: string | null): string {
  if (temFuro === undefined || temFuro === null) {
    return "N/A";
  }

  if (!temFuro) {
    return "Sem furo";
  }

  if (!tipoFuro) {
    return "Com furo";
  }

  return tipoFuro.charAt(0).toUpperCase() + tipoFuro.slice(1);
}
